<template>
    <span v-if="enableSmartLinks" v-bind="attributes">
        <slot></slot>
    </span>
  <template v-else>
    <slot></slot>
  </template>
</template>
<script setup lang="ts">
const props = defineProps<{ codename: string, itemId?: string }>()
const enableSmartLinks = useRuntimeConfig().public.enableSmartLinks
const attributes: Record<string, any> = {}
if (enableSmartLinks) {
  attributes['data-kontent-element-codename'] = props.codename
  if (props.itemId) {
    attributes['data-kontent-item-id'] = props.itemId
  }
}
</script>